﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalWPM`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetCompanyListByAgency' },
  { name: 'GetEmployeesByCompanyID' },
  { name: 'GetSuffixDropDown' },
  { name: 'GetGenderDropDown' },
  { name: 'GetEmployeeTypes' },
  { name: 'InsertCompany' },
  { name: 'DeleteCompany' },
  { name: 'GetIssueAge' },
  { name: 'PrintList' },
  { name: 'PrintRoster' },
  { name: 'UpdateEmployee' },
  { name: 'InsertEmployee' },
  { name: 'DeleteEmployee' },
  { name: 'BulkUpdateEffective' },
  { name: 'UploadFile' },
  { name: 'ImportRecords' },
]);

const GetCompanyListByAgency = () => api.endpoints.GetCompanyListByAgency.post();
const GetEmployeesByCompanyID = (body) => api.endpoints.GetEmployeesByCompanyID.post(body);
const GetSuffixDropDown = () => api.endpoints.GetSuffixDropDown.post();
const GetGenderDropDown = () => api.endpoints.GetGenderDropDown.post();
const GetEmployeeTypes = () => api.endpoints.GetEmployeeTypes.post();
const InsertCompany = (body) => api.endpoints.InsertCompany.post(body);
const DeleteCompany = (body) => api.endpoints.DeleteCompany.post(body);
const GetIssueAge = (body) => api.endpoints.GetIssueAge.post(body);
const PrintList = (body) => api.endpoints.PrintList.post(body);
const PrintRoster = (body) => api.endpoints.PrintRoster.post(body);
const UpdateEmployee = (body) => api.endpoints.UpdateEmployee.post(body);
const InsertEmployee = (body) => api.endpoints.InsertEmployee.post(body);
const DeleteEmployee = (body) => api.endpoints.DeleteEmployee.post(body);
const BulkUpdateEffective = (body) => api.endpoints.BulkUpdateEffective.post(body);
const UploadFile = (data) => api.endpoints.UploadFile.postData(data);
const ImportRecords = (data) => api.endpoints.ImportRecords.postData(data);

export {
  GetCompanyListByAgency,
  GetEmployeesByCompanyID,
  GetSuffixDropDown,
  GetGenderDropDown,
  GetEmployeeTypes,
  InsertCompany,
  DeleteCompany,
  GetIssueAge,
  PrintList,
  PrintRoster,
  UpdateEmployee,
  InsertEmployee,
  DeleteEmployee,
  BulkUpdateEffective,
  UploadFile,
  ImportRecords,
};
